import { CONSTANTS } from 'utils';
import { IModuleRoute, AppRouteNamesList, RoleTypes } from 'models';

export enum SurveyTrackingPathList {
	surveyTracking = '/tracking',
	emailsEdit = '/edit/emails',
}
const requiredRoles = [
	RoleTypes.PRIMARY_ADMIN,
	RoleTypes.ADMIN,
	RoleTypes.SUPER_ADMIN,
];

export const surveyTrackingRoutes: IModuleRoute = {
	path: `${CONSTANTS.moduleAdminPath}${SurveyTrackingPathList.surveyTracking}`,
	name: AppRouteNamesList.surveyTracking,
	requiredRoles,
	nested: [
		{
			path: `${SurveyTrackingPathList.emailsEdit}`,
			name: AppRouteNamesList.emailsEdit,
			requiredRoles,
		},
	],
};
